import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import Proposal from "../../../proposal/proposal.component"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { OrderDto } from "../../../state/order/Order"

type OwnProps = {
    object: EventObjectDto
    order: OrderDto
    proposal: Proposal
}

const OrderExportedToZendeskSupportEvent = (props: OwnProps) => {
    const Url = Integrations.getExternalOrderUrl(props.object)
    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"} data-document-event="order-exported">
                    {<FormattedMessage
                        id="order.analytics.events.exported.zendesk_support.text"
                        defaultMessage="Order {identifier} was created from Zendesk support, ticket #{externalId}"
                        values={{
                            identifier: <strong>{props.order.attributes.identifier}</strong>,
                            externalId:  props.object.attributes.externalId,
                        }}
                    />}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(INTEGRATION_KEY.ZENDESK_SUPPORT, 80, 21)}
                    </a>
                </div>
                {Url &&
                    <div className={""}>
                        <p className={"mb-0"}>
                            <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                                <FormattedMessage
                                    id="order.analytics.events.exported.zendesk_support.open"
                                    defaultMessage="Open ticket in Zendesk support"
                                />
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}


export default OrderExportedToZendeskSupportEvent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-exported-zendesk-support.component.tsx